import React from 'react';
import AsyncTerms from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <BlankLayout
    key="/business/terms"
    exact
    path="/business/terms"
    component={AsyncTerms}
  />
);
